import React, { useEffect, useState } from 'react';
import './App.less';
import Cookies from 'universal-cookie';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import DashboardHome from './components/DashboardHome';


interface Props {
  currentUser: any;
  handleUserChange: any;
  logoutHandler: any;
}
const App: React.FC<Props> = ({ currentUser, handleUserChange, logoutHandler }) => {
  const cookies = new Cookies();
  const [user, setUser] = useState(
    currentUser !== undefined && currentUser !== null
    ? currentUser
    : currentUser === null
    ? null
    : undefined
  );

  useEffect(() => {
      if (user) {
          // If the user is authenticated, remove the scientia_url cookie        
        cookies.remove('scientia_url', {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});                     
    }
  }, []);

  return (
    <Routes>
     <Route path="/" element={
        <Dashboard
          currentUser={currentUser}
          logoutHandler={logoutHandler}
          />
      } />
     <Route path="/login"
      element={
          <DashboardHome
              key={JSON.stringify(user)}
              currentUser={currentUser}
              handleUserChange={handleUserChange}
              logoutHandler={logoutHandler}
          />
        }
      />
  </Routes>
  );
}

export default App;
